import React, { useState, useRef, useEffect } from 'react';
import { getLimits, getLimitById, updateLimit, softDeleteLimit, getMenuLimits } from '../../Services/LimitService';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import Overlay from '../../Components/Overlay/Overlay';
import { handlerFormError, uuid } from '../../Utils/Utils';
import EditButton from '../../Components/Button/EditButton';
import { useDispatch } from 'react-redux';
import { setModuleName } from '../../Stores/Action/AppAction';

let processingId = -1;

const LimitScreen = () => {
    const mTable = useRef();
    const dispatch = useDispatch();
    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        defaultValues: {
            bucket_name: '',
            id: '',
            code: '',
            name: '',
            size: '',
            used: '',
            free: '',
            tSize: 0, 
            is_active: true
        }
    });

    const [state, setState] = useState({
        showForm: false,
        limits : {},
        menus: [],
        processing: false
    });

    useEffect(() => {
        dispatch(setModuleName('Filter'));
        getMenuLimits(1).then(res => {
            let tSize = 0;
            res.data.data.map((item, i) => {
                tSize += Number(item.storage.size);
            })
            setState({ ...state, menus: res.data.data, tSize: tSize });
        });
    }, []);

    const onChangeSize = e => {
        if(Number(e.target.value) < 0){
            Swal.fire({
                icon: 'error',
                title: 'Update storage size failed!',
                text: 'Value must be greater than 0'
            }).then( e.target.value = 0 )
        }else{
            const { menus, limits } = state;
            let index = e.target.id.split('_').pop();
            let tSize = 0;
            let bucketSize = limits.bucket_size.size;
            menus.map((item, i) => {
                if (index != i)
                    tSize += Number(item.storage.size);
                else
                    tSize += Number(e.target.value);
            });

            updateSizeStorage(index, 'storage', 'size', e.target.value, tSize);

            if(bucketSize < tSize){
                Swal.fire({
                    icon: 'error',
                    title: 'Update storage size failed!',
                    text: 'Storage per Name\'s, exceeds the maximum Bucket limit : ' + bucketSize + ' GB'
                }).then( e.target.value = 0 )
            }
        }
    }

    const updateSizeStorage = (index, itemAttributes, sizeAttributes, value, newSize) => {
        const temp = [...menus];
        temp[index][itemAttributes][sizeAttributes] = Number(value);
        setState( { ...state, menus: temp, tSize: newSize } );
    }

    const columns = [
        { id: uuid(), title: 'Bucket Name', field: 'bucket_name', sortable: false },
        {
            id: uuid(),
            title: 'Bucket Size in GB',
            sortable: false,
            render: item => {
                return <div><span>Size : { item.bucket_size.size.toFixed(2) }</span><br /><span>Total Used : { item.bucket_size.used.toFixed(2) }</span><br /><span>Free : { item.bucket_size.free.toFixed(2) }</span></div>;
            },
        },
        {
            id: uuid(),
            title: 'Storage Name',
            sortable: false,
            render: item => {
                return <div>
                    {
                        item.bucket_used?.map((nm, i) => <div><span>{ nm.name }</span><br /></div>)
                    }
                    </div>
                
            },
        },
        {
            id: uuid(),
            title: 'Storage Size',
            sortable: false,
            style: { textAlign: `right` },
            render: item => {
                return <div>
                {
                    item.bucket_used?.map((nm, i) => <div><span>{ nm.size }</span><br /></div>)
                }
                </div>
            },
        },
        {
            id: uuid(),
            title: 'Storage Used',
            sortable: false,
            style: { textAlign: `right` },
            render: item => {
                return <div>
                {
                    item.bucket_used?.map((nm, i) => <div><span>{ nm.used.toFixed(2) }</span><br /></div>)
                }
                </div>
            },
        },
        {
            id: uuid(),
            title: 'Storage Free',
            sortable: false,
            style: { textAlign: `right` },
            render: item => {
                return <div>
                {
                    item.bucket_used?.map((nm, i) => <div><span>{ nm.free.toFixed(2) }</span><br /></div>)
                }
                </div>
            },
        },
        {
            id: uuid(),
            title: 'Units',
            sortable: false,
            render: item => {
                return <div>
                    {
                        item.bucket_used?.map((nm, i) => <div><span>{ item.bucket_unit }</span><br /></div>)
                    }
                    </div>
                
            },
        },
        {
            id: uuid(),
            title: 'Action',
            sortable: false,
            style: { textAlign: `center` },
            render: item => {
                return (
                    <div>
                        <EditButton title="Edit" onClick={onEdit(item)} />
                    </div>);
            },
        },
    ];

    const propsTable = { columns, getData: getLimits, enableFilter: true, showAddButton: false, hideFilter: true, filterRule: 'filter' };


    const onEdit = item => () => {
        reset(item);
        setState({ ...state, limits: item, showForm: true });
    }

    const onAddData = () => {
        onReset();
        setState({ ...state, showForm: true });
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const onSubmit = (data) => {
        startProcessing();

        const response = updateLimit(limits._id, data);
        response.then(res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Save data success',
                    text: 'Data has been saved!'
                }).then(r => {
                    mTable.current.refresh();
                    limits._id ? onCloseForm() : onReset();
                })
            }
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onReset = () => {
        reset({
            limit_name: '',
            is_active: true
        });
        setState({ ...state, storage_limit: {} });
    }

    const onCloseForm = () => {
        reset({
            limit_name: '',
            is_active: true
        });
        setState({ ...state, storage_limit: {}, showForm: false });
    }

    const { limits, processing, showForm, menus, tSize, tNewSize } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} />
                                <div className="card-header">
                                    <div className="card-title">
                                        <i className="fas fa-tags mr-1" />
                                        {showForm ? ' Form Storage' : ' List Storage'}
                                    </div>
                                </div>

                                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-body'>
                                        <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}>
                                            <MTable ref={mTable} {...propsTable} onAddData={onAddData} showIndex={true} />
                                        </div>

                                        <div className={`${showForm ? 'card__side--back-show' : 'card__side--back'}`}>
                                            <div className='row'>
                                            <label htmlFor="type_code">Fields with <span className='mandatory'></span> are required.</label>
                                                <div className="col-md-6">
                                                    <div className='form-group'>
                                                    <label htmlFor="storage_name">Storage Name :</label>
                                                    {
                                                        menus?.map((item, i) => (
                                                            <div key={'name_'+i} style={{ paddingTop: `5px`}}>    
                                                                <input id={'name_' + i} {...register("name["+i+"]")} className='form-control' value={item.menu_name} readOnly={true} style={{ background: `#e9ecef` }} />
                                                                <input type="hidden" id={'id_' + i} {...register("id["+i+"]")} value={item._id} />
                                                                <input type="hidden" id={'code_' + i} {...register("code["+i+"]")} value={item.menu_code} />
                                                            </div>
                                                        ))
                                                    }
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className='form-group'>
                                                    <label htmlFor="storage_name" className='mandatory'>Size :</label>
                                                    {
                                                        menus?.map((item, i) => (
                                                            <div key={'new_size_'+i} style={{ paddingTop: `5px`}}>    
                                                                <input id={'size_' + i} {...register("size["+i+"]", { required: { message: 'Storage Size is required!' } })} style={{ textAlign: `right` }} className='form-control' defaultValue={item.storage.size} onChange={onChangeSize} type="number" />
                                                                {errors.size && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.size.message}</span>)}
                                                            </div>
                                                        ))
                                                    }
                                                        <div style={{ paddingTop: `5px`}}>   
                                                            <input id='tSize' className='form-control' value={tSize} readOnly={true} style={{ background: `#e9ecef`, textAlign: `right`,  }}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className='form-group'>
                                                    <label htmlFor="storage_name">Used :</label>
                                                    {
                                                        menus?.map((item, i) => (
                                                            <div key={'used_'+i} style={{ paddingTop: `5px`}}>    
                                                                <input id={'used_' + i} className='form-control' {...register("used["+i+"]")} value={item.storage.used.toFixed(2)} readOnly={true} style={{ background: `#e9ecef`, textAlign: `right` }} />
                                                            </div>
                                                        ))
                                                    }
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className='form-group'>
                                                    <label htmlFor="storage_name">Free :</label>
                                                    {
                                                        menus?.map((item, i) => (
                                                            <div key={'free_'+i} style={{ paddingTop: `5px`}}>    
                                                                <input id={'free_' + i} className='form-control' {...register("free["+i+"]")} value={item.storage.free.toFixed(2)} readOnly={true} style={{ background: `#e9ecef`, textAlign: `right` }} />
                                                            </div>
                                                        ))
                                                    }
                                                    </div>
                                                </div>                       
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        showForm && <div className='card-footer delay'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                        <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onCloseForm}><i className='fa fa-times' /> Close</button>
                                                        <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-sync' /> Clear</button>
                                                        <button type='submit' className='btn btn-dark' style={{ width: 100 }}
                                                        >
                                                            <i className='fa fa-save' /> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LimitScreen;